"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClear = void 0;
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var actions_1 = require("../store/cart/actions");
var actions_2 = require("../store/payment/actions");
var actions_3 = require("../store/product/actions");
var useClear = function (_a) {
    var id = _a.id;
    var searchParams = new URLSearchParams(location.search);
    var type = searchParams.get('type') || '';
    var dispatch = (0, react_redux_1.useDispatch)();
    var clear = (0, react_1.useCallback)(function () {
        dispatch((0, actions_1.cartClear)());
        dispatch((0, actions_2.clearPayment)());
        dispatch((0, actions_3.clearProduct)());
    }, []);
    (0, react_1.useEffect)(function () {
        var restaurantIdFromStorage = JSON.parse(localStorage.getItem('restaurant') || '{}');
        if (!restaurantIdFromStorage.id && !restaurantIdFromStorage.type) {
            clear();
            localStorage.setItem('restaurant', JSON.stringify({ id: id, type: type }));
        }
        if ((restaurantIdFromStorage.id && restaurantIdFromStorage.id !== String(id)) || restaurantIdFromStorage.type !== type) {
            clear();
            localStorage.setItem('restaurant', JSON.stringify({ id: id, type: type }));
        }
    }, []);
};
exports.useClear = useClear;
